import { Typography } from 'antd'
import React, { ReactElement } from 'react'
import { HeroImage } from '../FrontPage/FrontPage';
import { ContentContainer } from './components/ContentContainer';
import ConfigurationForm from './ConfigurationForm';

export default function AlertsConfigurationPage(): ReactElement {
    return (
        <HeroImage>
            <ContentContainer>
                <Typography.Title level={4}>Sähköpostihälytykset metsänkäyttöilmoituksista</Typography.Title>
                <ConfigurationForm />
            </ContentContainer>
        </HeroImage>
    )
}
